import '../stylesheets/style.scss';
const Util = require("./util.js");
import {arrow} from '@tightrope/newtab';
const TOP_DOMAIN = Util.TOP_DOMAIN;
const Shortcuts = require("./Shortcuts.js");

var searchElement = 'search_field';
if(searchElement && searchElement !== ""){
	window._tr_ac_se = searchElement;
}

$(document).ready(async function()
{
	arrow("search");
	$("#search_field").focus();
	let currentDate = Util.getCurrentDate();
	$("#current_date").text(currentDate);
	Shortcuts.loadShortcuts("#favor");
	var cookieA= Util.getSetting("pointA");
	var cookieB= Util.getSetting("pointA");
	var userGuid = await Util.getGuid();
	if (cookieA !== "")
		$(".pointA").val(cookieA);
	else
		Util.getUserLocation().then(location => {
			if (location && location.city && location.state) {
				$(".pointA").val(location.city + ', ' + location.state);
			}
		});
	if (cookieB !== "")
		$(".pointB").val(cookieB);
	if (Util.isFirstRun())
	{
		$(".span").addClass('spanActive');
		$(".container").addClass("container-active");
	}

	$(document).on('click', '.getDirections', processMapQuery);
	$(document).on('click', '#dl_install, #closeModal', function() {
		$('#lightbox').fadeOut('fast');

	});
	$(document).on('click', '.footerlinks', trackFooterLinks);

	// Tracking
	$(document).on('click', '#favor a', function(e) {
		trackBkmkClick(e);
	});
	Util.updateClockOnDOM(".clock", false);
	$(document).on('submit', '.s-btn', trackSubmit);
	setInterval(() => {
		Util.updateClockOnDOM(".clock", false);
	}, 1000);
	$(".transBox div").click(function() {
		var type=$(this).attr("type");
		var class_name=type+"Active";
		$(".transBox div").each(function(i,item){
			$(item).removeClass($(item).attr("type")+"Active");
			$(item).removeClass("active");
		});
		$(this).addClass(class_name);
		$(this).addClass("active");
	});
	$(".mapList a").click(function(ev){
		ev.preventDefault();
		$(".span").addClass('spanActive');
		$(".container").addClass("container-active");
		var value=$(this).attr("map");
		$('#mapChoice option[value="'+value+'"]').prop('selected', true);
	});
	if ($("#guid_field").val()=="")
		$("#guid_field").val(userGuid);

	$("#searchForm").submit(function(e) {
		e.preventDefault();
		window.location = "https://services." + TOP_DOMAIN + "/crx/search.php?action=nt&guid=" + userGuid + "&k=" + $("#search_field").val();
		if ($("#guid_field").val()=="")
			$("#guid_field").val(userGuid);
	});
	$(document).on('click', '.slideBtn', function(e) {
		$(".span").toggleClass('spanActive');
		$(".container").toggleClass('container-active');
	});

	$(".footerlinks a").each(function(i, obj) {
		obj.href = "//" + TOP_DOMAIN + obj.getAttribute("href");
	});

});

// End of Document Ready

function processMapQuery() {
	var mapChoice = $("#mapChoice").val();
	trackGetDirections(mapChoice);
	var pointA = $(".pointA").val();
	var pointB = $(".pointB").val();
	var type=$(".transBox div.active").attr("type");
	var url;
	switch(mapChoice) {
		case "google":
		switch (type)
		{
			case "car":
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&driving";
			break;
			case "train":
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&travelmode=transit";
			break;
			case "walk":
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&travelmode=walking";
			break;
			case "bike":
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&travelmode=bicycling";
			break;
			case "plane":
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&travelmode=air";
			break;
			default:
			url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&driving";
		}
		break;
		case "yahoo":
		switch (type)
		{
			case "car":
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB;
			break;
			case "train":
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB+"&mode=11&dep=1521471660";
			break;
			case "walk":
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB+"&mode=6";
			break;
			case "bike":
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB;
			break;
			case "plane":
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB;
			break;
			default:
			url = "https://maps.yahoo.com/directions-app/directions/?o="+pointA+"&d="+pointB;
		}
		break;
		case "bing":
		switch (type)
		{
			case "car":
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
			break;
			case "train":
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
			break;
			case "walk":
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
			break;
			case "bike":
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
			break;
			case "plane":
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
			break;
			default:
			url = "https://www.bing.com/mapspreview?rtp=adr."+pointA+"~adr."+pointB+"&rtop=0~1~0";
		}
		break;
		case "mapquest":
		switch (type)
		{
			case "car":
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB;
			break;
			case "train":
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB;
			break;
			case "walk":
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB+"&routeType=pedestrian";
			break;
			case "bike":
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB;
			break;
			case "plane":
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB;
			break;
			default:
			url = "https://www.mapquest.com/directions?q1="+pointA+"&q2="+pointB;
		}
		break;
		default:
		url = "https://www.google.com/maps/dir/?api=1&origin="+pointA+"&destination="+pointB+"&driving";
	}
	Util.openUrl(url);
}
